import { render } from "./StockStar.vue?vue&type=template&id=80224340&scoped=true"
import script from "./StockStar.vue?vue&type=script&lang=js"
export * from "./StockStar.vue?vue&type=script&lang=js"

import "./StockStar.vue?vue&type=style&index=0&id=80224340&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-80224340"

export default script